const ArrowDownLeftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
    >
      <path
        d="M0 11V3.38462H0.846154V9.55477L10.4009 0L11 0.599077L1.44523 10.1538H7.61538V11H0Z"
        fill="#10B981"
      />
    </svg>
  );
};
export default ArrowDownLeftIcon;
